module.exports = __webpack_public_path__ + "img/VinoTintoCaymusSpecialSelection.78647582.jpg";